import { coerceBooleanLike } from './coerce-boolean-like';
import { TIME_PIVOT, transformTime } from './transform-time';
import { createResolvePivotKey } from '../shared/resolve-pivot-key';
import { NormalizedUnitValue } from '../shared/types';

const TIME_TARGET_PIVOT: Record<string, number> = {
  ...TIME_PIVOT,
  duration: 1,
  timer: 1,
};

const resolveTimeTargetKey = createResolvePivotKey(TIME_TARGET_PIVOT);

/**
 * Dimensionless / missing-unit sources adopt the target label. Also coerces
 * missing sources to seconds for time-family targets and to boolean labels
 * for boolean-family targets when the value is a genuine boolean.
 */
export function transformNone(
  unitValue: NormalizedUnitValue,
  newUnits?: string
): NormalizedUnitValue {
  const targetKey = newUnits?.toLowerCase();

  if (targetKey && resolveTimeTargetKey(newUnits!)) {
    return transformTime({ value: unitValue.value, units: 'sec' }, newUnits);
  }

  if (targetKey && targetKey !== 'string' && typeof unitValue.value === 'boolean') {
    return coerceBooleanLike(unitValue, newUnits!);
  }

  if (!targetKey && typeof unitValue.value === 'boolean') {
    const coerced = coerceBooleanLike(unitValue, 'boolean');
    return { ...coerced, units: 'boolean' };
  }

  return { value: unitValue.value, units: newUnits ?? '' };
}
